import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

export type ClassifiedsAdInactiveFlags = {
  isAvailable: boolean;
  isSold?: boolean | null;
  justSold?: boolean | null;
};

export type ClassifiedsAdInactiveReason = 'availabilityCheck' | 'inactiveListing';

/**
 * Classifieds-only grey-out / Sold flag / hide-actions decision.
 * Live `justSold` overrides occurrence-derived availability flags.
 */
export function isClassifiedsAdInactive(vehicle: ClassifiedsAdInactiveFlags | Nullish): boolean {
  if (isNil(vehicle)) {
    return true;
  }

  if (vehicle.justSold === true) {
    return true;
  }

  if (vehicle.justSold === false) {
    return false;
  }

  return vehicle.isAvailable === false || vehicle.isSold === true;
}

export function getClassifiedsAdInactiveReason(
  vehicle: ClassifiedsAdInactiveFlags | Nullish
): ClassifiedsAdInactiveReason | null {
  if (!isClassifiedsAdInactive(vehicle)) {
    return null;
  }

  return vehicle?.justSold === true ? 'availabilityCheck' : 'inactiveListing';
}
